// extracted by mini-css-extract-plugin
export default {"header2":"wFENLj"};